import {
  ShouldStartLoadRequest,
  WebViewErrorEvent,
  WebViewHttpErrorEvent,
} from 'react-native-webview/lib/WebViewTypes';
import { logNonFatalError } from 'shared/utils/sentry/sentry';

export const webViewAdditionalProps = {
  onShouldStartLoadWithRequest: (request: ShouldStartLoadRequest) => {
    return !request.url.includes('forbidden');
  },
  onError: (syntheticEvent: WebViewErrorEvent) => {
    const { nativeEvent } = syntheticEvent;
    logNonFatalError(nativeEvent.description);
  },
  onHttpError: (syntheticEvent: WebViewHttpErrorEvent) => {
    const { nativeEvent } = syntheticEvent;
    logNonFatalError(nativeEvent.description);
  },
  setSupportMultipleWindows: false,
};
